module.exports = __webpack_public_path__ + "static/media/help.4f80ff31.jpg";